import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokMedia } from "@/storyblok";
import { AssetBlok } from "../Asset";
import styles from "./Media.module.css";

export const MediaBlok = ({
	blok,
	sizes,
	className,
}: BlokProps<BlokMedia> & {
	sizes?: string;
	className?: string;
}) => {
	return (
		<BlokWrap
			editable={blok}
			as="div"
			className={clsx(styles.root, className)}
			style={
				{
					"--blok-aspect-ratio": blok.aspectRatio,
				} as React.CSSProperties
			}
		>
			<AssetBlok sizes={sizes} source={blok.media} />
		</BlokWrap>
	);
};
